import script from "./TaskPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskPanel.vue?vue&type=script&setup=true&lang=js"

import "./TaskPanel.vue?vue&type=style&index=0&id=fe6ae236&lang=less&scoped=true"
import "./TaskPanel.vue?vue&type=style&index=1&id=fe6ae236&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fe6ae236"]])

export default __exports__